export default __webpack_public_path__ + "static/media/icons-project-payment.37d16628.svg";